// Shared helpers for the IoT screens.
import dayjs from "dayjs";

// access_module names (seeded by `manage.py seed_iot_integration` / setup_access_modules)
export const IOT_CONFIG_MODULE = "IoT Configuration";
export const IOT_LIVE_MODULE = "IoT Live Monitoring";
export const PLC_WRITE_MODULE = "PLC Write";

export const DATA_TYPE_OPTIONS = [
  { value: "boolean", label: "Boolean" },
  { value: "integer", label: "Integer" },
  { value: "float", label: "Float" },
  { value: "string", label: "String" },
];

const NUMERIC_TYPES = ["int", "integer", "float", "double", "decimal", "number", "numeric"];
export const isNumericType = (t) => NUMERIC_TYPES.includes(String(t || "").toLowerCase());
export const isBooleanType = (t) => ["boolean", "bool"].includes(String(t || "").toLowerCase());

export const getModuleAccess = (moduleName) => {
  let list = [];
  try {
    list = JSON.parse(localStorage.getItem("access_list_data")) || [];
  } catch (e) {
    list = [];
  }
  const row = Array.isArray(list) ? list.find((item) => item.module_name === moduleName) : undefined;
  return {
    read: !!row?.read_access,
    create: !!row?.create_access,
    update: !!row?.update_access,
    delete: !!row?.delete_access,
  };
};

export const formatDateTime = (value) => (value ? dayjs(value).format("DD-MM-YYYY HH:mm:ss") : "-");

export const isTruthyValue = (value) =>
  ["1", "true", "t", "yes", "y", "on", "open", "start"].includes(String(value ?? "").trim().toLowerCase());

export const formatTagValue = (value, dataType, unit) => {
  if (value === null || value === undefined || value === "") return "-";
  if (isBooleanType(dataType)) return isTruthyValue(value) ? "ON" : "OFF";
  const num = Number(value);
  const text = Number.isFinite(num) && String(value).includes(".") ? num.toFixed(2) : String(value);
  return unit ? `${text} ${unit}` : text;
};

export const alarmLimitsText = (r) => {
  const unit = r.unit_name ? ` ${r.unit_name}` : "";
  if (r.low_limit != null && r.high_limit != null) return `${r.low_limit} – ${r.high_limit}${unit}`;
  if (r.high_limit != null) return `≤ ${r.high_limit}${unit}`;
  if (r.low_limit != null) return `≥ ${r.low_limit}${unit}`;
  return null;
};

// Card wrapper in the app's standard page style (white card, header with icon).
export const PAGE_CARD = "bg-white rounded-lg border border-gray-200 shadow-sm";

// Notification look: severity colour and category label/icon colour
export const SEVERITY_COLORS = { critical: "red", high: "volcano", medium: "orange", low: "green", info: "blue" };
export const NOTIFICATION_CATEGORIES = [
  { value: "alarm", label: "Alarm raised" },
  { value: "alarm_cleared", label: "Alarm cleared" },
  { value: "ticket", label: "Ticket raised" },
  { value: "ticket_failed", label: "Ticket not raised" },
  { value: "pm_due", label: "Run-hour PM" },
  { value: "status_change", label: "Machine status changed" },
  { value: "plc_write", label: "PLC write" },
  { value: "sync_error", label: "EdgeNexus sync error" },
  { value: "system", label: "System" },
];

// "5 min ago" style time
export const timeAgo = (value) => {
  if (!value) return "";
  const sec = Math.max(0, Math.round((Date.now() - new Date(value).getTime()) / 1000));
  if (sec < 60) return "just now";
  if (sec < 3600) return `${Math.floor(sec / 60)} min ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)} h ago`;
  return `${Math.floor(sec / 86400)} d ago`;
};
